export default "__VITE_ASSET__CNwQrxK4__"